module.exports = __webpack_public_path__ + "img/Comunicacion.f8f321ec.svg";